import axios from 'axios'
import { Market } from '@libs/types/generated/markets-api'

const getAll = async (): Promise<Market[]> => {
  const response = await axios.post(
    `${process.env.NEXT_PUBLIC_MARKETS_SERVICE_URL}/search`,
    {
      query: {},
      omit_fields: ['attributes', 'description', 'locations'],
      disable_cache: false
    }
  )

  return response.data.results
}

const marketsApi = {
  getAll
}

export default marketsApi
